import { Button } from '@fluentui/react-components';
import { FeatureDefinition } from '../../types/feature.types';
import logoSrc from '../../../assets/logo.svg';

interface NavigationProps {
  features: FeatureDefinition[];
  activeFeatureId: string;
  onFeatureSelect: (id: string) => void;
}

/**
 * Slim vertical icon rail for switching top-level workspaces (AI Buddy / Tools /
 * Config). Deliberately narrow — icon-only, ~40px — so it costs almost no
 * horizontal space in the tall-narrow task pane. Hover/aria labels name each.
 */
export const Navigation: React.FC<NavigationProps> = ({
  features,
  activeFeatureId,
  onFeatureSelect,
}) => {
  return (
    <div
      role="tablist"
      aria-orientation="vertical"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: '6px 4px',
        borderRight: '1px solid #ececec',
        flexShrink: 0,
      }}
    >
      <img
        src={logoSrc}
        alt="V14 Word Toolbox"
        style={{ width: 28, height: 'auto', margin: '2px auto 8px', display: 'block' }}
      />
      {features.map((feature) => {
        const Icon = feature.icon;
        const active = feature.id === activeFeatureId;
        return (
          <Button
            key={feature.id}
            role="tab"
            aria-selected={active}
            aria-label={feature.name}
            title={feature.name}
            appearance={active ? 'primary' : 'subtle'}
            icon={<Icon />}
            onClick={() => onFeatureSelect(feature.id)}
            style={{ minWidth: 34, width: 34, height: 34, padding: 0 }}
          />
        );
      })}
    </div>
  );
};
